// extracted by mini-css-extract-plugin
export default {"btn":"ScrollToTopBtn_btn__b1TFR","visible":"ScrollToTopBtn_visible__r8XSU","hidden":"ScrollToTopBtn_hidden__moQGf"};